<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Estágio</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Estágio</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="sigla">Sigla</label>
                                    <input type="text" class="form-control" name="sigla" placeholder="Sigla" v-model="filter.sigla" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="nivelId">Nível</label>
                                    <select v-select="{ dataitem: 'Nivel', default: 'Selecione' }" v-model="filter.nivelId" class="form-control" name="nivelId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="publicoAlvoMinimo">Idade do Público Alvo Mínimo</label>
                                    <input type="number" class="form-control" name="publicoAlvoMinimo" placeholder="Idade do Público Alvo Mínimo" v-model="filter.publicoAlvoMinimo" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="publicoAlvoMaximo">Idade do Público Alvo Máximo</label>
                                    <input type="number" class="form-control" name="publicoAlvoMaximo" placeholder="Idade do Público Alvo Máximo" v-model="filter.publicoAlvoMaximo" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="vagasMinima">Vagas Mínima</label>
                                    <input type="number" class="form-control" name="vagasMinima" placeholder="Vagas Mínima" v-model="filter.vagasMinima" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="vagasMaxima">Vagas Máxima</label>
                                    <input type="number" class="form-control" name="vagasMaxima" placeholder="Vagas Máxima" v-model="filter.vagasMaxima" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="ordem">Ordem</label>
                                    <input type="number" class="form-control" name="ordem" placeholder="Ordem" v-model="filter.ordem" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="mediaAprovacao">Média Aprovação</label>
                                    <input type="text" class="form-control" name="mediaAprovacao" placeholder="Média Aprovação" v-model="filter.mediaAprovacao" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="duracao">Duração</label>
                                    <input type="text" class="form-control" name="duracao" placeholder="Duração" v-model="filter.duracao" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="fatorAvaliacao">Fator Avaliação</label>
                                    <input type="text" class="form-control" name="fatorAvaliacao" placeholder="Fator Avaliação" v-model="filter.fatorAvaliacao" />
                                </div>


                                <div class="form-group col-md-2">
                                    <label>Ativo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>


                                <div class="form-group col-md-2">
                                    <label>Inicial</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inicial" v-model="filter.inicial" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inicial" v-model="filter.inicial" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inicial" v-model="filter.inicial" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-2">
                                    <label>Final</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="final" v-model="filter.final" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="final" v-model="filter.final" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="final" v-model="filter.final" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>


                                <div class="form-group col-md-4">
                                    <label>Avaliação Por Conceito</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="avaliacaoPorConceito" v-model="filter.avaliacaoPorConceito" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="avaliacaoPorConceito" v-model="filter.avaliacaoPorConceito" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="avaliacaoPorConceito" v-model="filter.avaliacaoPorConceito" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>


                                <div class="form-group col-md-4">
                                    <label>Pode Criar Turma</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="podeCriarTurma" v-model="filter.podeCriarTurma" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="podeCriarTurma" v-model="filter.podeCriarTurma" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="podeCriarTurma" v-model="filter.podeCriarTurma" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Id<i @click="executeOrderBy('EstagioId')" class="fa fa-sort"></i></th>
                                    <th>Nome<i @click="executeOrderBy('Nome')" class="fa fa-sort"></i></th>
                                    <th>Sigla<i @click="executeOrderBy('Sigla')" class="fa fa-sort"></i></th>
                                    <th>Avaliação Por Conceito<i @click="executeOrderBy('AvaliacaoPorConceito')" class="fa fa-sort"></i></th>
                                    <th>Ordem<i @click="executeOrderBy('Ordem')" class="fa fa-sort"></i></th>
                                    <th>Média Para Aprovação<i @click="executeOrderBy('MediaAprovacao')" class="fa fa-sort"></i></th>
                                    <th>Duração<i @click="executeOrderBy('Duracao')" class="fa fa-sort"></i></th>
                                    <th>Ativo<i @click="executeOrderBy('Ativo')" class="fa fa-sort"></i></th>
                                    <th>Inicial<i @click="executeOrderBy('Inicial')" class="fa fa-sort"></i></th>
                                    <th>Final<i @click="executeOrderBy('Inicial')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.estagioId }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.sigla }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.avaliacaoPorConceito, 'badge-danger': !item.avaliacaoPorConceito }">{{item.avaliacaoPorConceito ? 'Sim' : 'Não'}}</span></td>
                                    <td>{{ item.ordem }}</td>
                                    <td>{{ item.mediaAprovacao }}</td>
                                    <td>{{ item.duracao }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.inicial, 'badge-danger': !item.inicial }">{{item.inicial ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.final, 'badge-danger': !item.final }">{{item.final ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Configurar" @click="openConfigurar({ estagioId: item.estagioId })">
                                            <i class="fa fa-cog"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ estagioId: item.estagioId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning" v-b-tooltip title="Log de Alterações" @click="openLog(item)">
                                            <i class="fa fa-history"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-info" v-b-tooltip title="Importar/Exportar Excel" @click="openImportacao(item)">
                                            <i class="fa fa-file-excel-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="estagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLog" size="lg" :hide-footer="true" title="Log de Alterações">
            <form-log v-if="dialogLog" :id="estagioLogId" style="max-height: 400px; overflow-x: hidden; overflow-y: auto;" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import formLog from './form-log'

    export default {
        name: 'estagio',
        mixins: [base],
        components: { formCreate, formEdit, 'form-log': formLog },
        data() {
            return {

                resources: {
                    filter: 'estagio',
                    remove: 'estagio'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogLog: false,
                estagioLogId: 0,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    nivelId: "",
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openConfigurar: function (model) {
                this.$router.push({ path: '/estagio/configuracao/' + model.estagioId });
            },
            openEdit: function (model) {
                this.estagioId = model.estagioId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            openImportacao: function (model) {
                this.$router.push({ path: '/estagio/importacao/' + model.estagioId });
            },
            openLog: function (model) {
                //this.estagioIndiceRematricula = model.estagioIndiceRematricula;                
                this.estagioLogId = model.estagioId;
                this.dialogLog = true;
                console.log(model);
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>